import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { ExternalUrl } from '../../models/external-url';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalUrlsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  externalUrlsEndpoint = this.config.patientApiUrl + '/v1/PatientPortal/ExternalUrls';

  getExternalUrls(): Observable<ExternalUrl[]> {
    return this.utilityService.getRequest<ExternalUrl[]>(this.externalUrlsEndpoint);
  }
}
